import { render } from "./DragAndDropDocument.vue?vue&type=template&id=59c39587&ts=true"
import script from "./DragAndDropDocument.vue?vue&type=script&lang=ts"
export * from "./DragAndDropDocument.vue?vue&type=script&lang=ts"

import "./DragAndDropDocument.vue?vue&type=style&index=0&id=59c39587&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__